import { render, staticRenderFns } from "./messageBoxList.vue?vue&type=template&id=40b36383&scoped=true"
import script from "./messageBoxList.vue?vue&type=script&lang=js"
export * from "./messageBoxList.vue?vue&type=script&lang=js"
import style0 from "./messageBoxList.vue?vue&type=style&index=0&id=40b36383&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b36383",
  null
  
)

export default component.exports